import React, { useState } from "react";
import classes from "../assets/styles/Pages/Function/ViewEmergencyContact.module.css";
import "react-phone-input-2/lib/material.css";
import contacticon from "../assets/images/function_page_icons/contacticon.svg";
import playstore from "../assets/images/footer_icons/playstore.svg";
import appstore from "../assets/images/footer_icons/appstore.svg";
import Image from "react-bootstrap/Image";
import { EMERGENCY_CONTACT_VCF_FILE_URL } from "../utils/constants/apiUrl";
import { post } from "../server";
import { loggedInUser } from "../utils/store";
import { useAtom } from "jotai";
import showToast from "../helpers/showToast";
import baseURL from "../utils/constants/baseUrl";
import { useParams } from "react-router-dom";
import dummyImage from "../assets/images/global_icons/dummyimage.png";
import _ from "lodash";
import formatPhoneNumber from "../helpers/formatPhoneNumber";

const CreateEmergencyContact = ({ emergencyContact }) => {
  const [loggedUser, setLoggedUser] = useAtom(loggedInUser);
  const [VCFData, setVCFData] = useState(emergencyContact);
  const [imageLoaded, setImageLoaded] = useState(false);

  const { uuid } = useParams();

  const [showFullText, setShowFullText] = useState(false);
  const displayText = showFullText
    ? emergencyContact?.description
    : emergencyContact?.description?.length > 60
    ? emergencyContact?.description?.slice(0, 60) + "..."
    : emergencyContact?.description;

  const toggleText = () => {
    setShowFullText(!showFullText);
  };

  const handleVcfFile = async () => {
    let { status, message, data } = await post(
      EMERGENCY_CONTACT_VCF_FILE_URL + `/${VCFData.uuid}`,
      VCFData,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null
    );
    if (status) {
      const link = document.createElement("a");
      link.download = "temp.vcf";
      link.href = data.url;
      link.click();
    } else {
      showToast(status, message);
    }
  };

  // const loadEmergencyContact = async () => {
  //   let { status, message, data } = await get(
  //     `${SHARE_EMERGENCY_CONTACT}/${uuid}`
  //   );

  //   setVCFData(data);
  //   if (status) {
  //     setEmergencyContact(data);
  //   } else {
  //     showToast(status, message);
  //   }

  //   setLoading(false);
  // };

  // useEffect(() => {
  //   loadEmergencyContact();
  // }, []);

  return (
    <>
      <div className="container">
        <div className="py-5">
          <div className="mainWrapper-emergency">
            <h6 className="title">Emergency Contact </h6>
            <div className="cardWrapper">
              <div className="">
                <div className="profileCardWrapper">
                  <div className="imgWrapper">
                    <Image
                      className="globalIMageFit"
                      src={
                        emergencyContact.image
                          ? `${baseURL.PUBLIC_URL}${emergencyContact.image}`
                          : dummyImage
                      }
                      alt="img"
                      roundedCircle={true}
                      onLoad={() => setImageLoaded(true)}
                    />
                  </div>
                  <div className="detailWrapper">
                    <h6>{`${emergencyContact.first_name || ""} ${
                      emergencyContact.last_name || ""
                    }`}</h6>

                    <p>{`+${emergencyContact.country_phone}${formatPhoneNumber(
                      emergencyContact.phone_number
                    )}`}</p>
                    <p className="description">
                      {displayText}

                      {emergencyContact?.description?.length > 60 && (
                        <button onClick={toggleText}>
                          {showFullText ? "Show Less" : "Read More"}
                        </button>
                      )}
                    </p>
                  </div>
                  <div className="text-center savePhonebookBtnWrapper mobileViewWrapper d-block">
                    <a
                      href={`tel: ${`+${emergencyContact.country_phone}${emergencyContact.phone_number}`}`}
                    >
                      <button className="primary_button mx-3">Call Now</button>
                    </a>
                    <button
                      className="primary_button mx-3"
                      onClick={handleVcfFile}
                    >
                      <span>{/* <img src={contacticon} alt="" /> */}</span>
                      Save Contact
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div className="cardFooter">
              <div className="d-flex align-items-center gap-3 justify-content-center">
                <a
                  href="https://play.google.com/store/apps/details?id=com.contactco.contactapp"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={playstore} alt="" />
                </a>
                <a
                  href="https://apps.apple.com/us/app/contact-co-connect-smarter/id6683301913"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img src={appstore} alt="" />
                </a>
              </div>
              <p>
                © {new Date().getFullYear()} Contact Co, All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CreateEmergencyContact;
